import React from 'react';
import ChemistryOfLeadership from '../components/ChemistryOfLeadership';

function ChemistryOfLeadershipPage() {
  return <ChemistryOfLeadership />;
}

export default ChemistryOfLeadershipPage;
